import {Mapper} from '@s-ui/domain'

export class FromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper extends Mapper {
  constructor({
    config,
    faqStructuredDataSeoMapper,
    fromRawVersionsToVehicleInsightsValueObjectMapper,
    fromRawFaqToFaqListValueObjectMapper,
    modelDetailContentValueObjectFactory
  }) {
    super()
    this._config = config
    this._faqStructuredDataSeoMapper = faqStructuredDataSeoMapper
    this._fromRawVersionsToVehicleInsightsValueObjectMapper = fromRawVersionsToVehicleInsightsValueObjectMapper
    this._modelDetailContentValueObjectFactory = modelDetailContentValueObjectFactory
    this._fromRawFaqToFaqListValueObjectMapper = fromRawFaqToFaqListValueObjectMapper
    this._type = '@type'
    this._faqPageType = 'FAQPage'
  }

  _getLocalizedValue = value => value?.[this._locale]

  _getProsAndCons = ({expertOpinion}) => {
    if (!expertOpinion) return []

    const {
      fields: {like, unlike}
    } = expertOpinion[this._locale]

    return {
      pros: this._getLocalizedValue(like),
      cons: this._getLocalizedValue(unlike)
    }
  }

  _getImages = ({imageGallery}) => {
    if (!imageGallery) return []

    const gallery = this._getLocalizedValue(imageGallery)
    const {fields: {photoGallery} = {}} = gallery || {}

    return (photoGallery && photoGallery[this._locale]) || []
  }

  _getFaqSEO = ({faqs}) => {
    if (!faqs) return []

    const seoFaqDataStructure = faqs.find(faq => faq[this._type] === this._faqPageType) || {}
    return this._faqStructuredDataSeoMapper.map({
      seoFaqDataStructure
    })
  }

  _getFaqs = ({faqs}) => {
    if (!faqs) return []

    const localizedFaqs = faqs.find(faq => faq[this._type] === this._faqPageType) || {}

    return this._fromRawFaqToFaqListValueObjectMapper.map({
      faqs: localizedFaqs?.mainEntity || []
    })
  }

  _getTitleFromVersions(versions) {
    if (!versions) return
    const [firstItem] = versions
    return `${firstItem?.make} ${firstItem?.model}`
  }

  setParams = ({locale}) => {
    this._locale = locale
    return this
  }

  _getPayloadInfo = (payload, title) => {
    if (!payload) return null
    const {fields = {}, rawFields = {}, defaultLocale} = payload
    this._locale = this._locale || defaultLocale

    const {expertOpinion: payloadExpertOpinion, imageGallery, subtitle, title: payloadTitle} = fields
    const photos = this._getImages({imageGallery})

    const {body} = rawFields

    const description = this._getLocalizedValue(subtitle)
    const expertOpinion = this._getProsAndCons({
      expertOpinion: payloadExpertOpinion
    })
    return {
      body: this._getLocalizedValue(body),
      description,
      ...expertOpinion,
      photos,
      title: this._getLocalizedValue(payloadTitle) || title
    }
  }

  _getFaqInfo = faqs => {
    return {faqs: this._getFaqs({faqs}), seoFaqs: this._getFaqSEO({faqs})}
  }

  map = ({data}) => {
    const title = null
    const {faqs, payload} = data

    const payloadInfo = this._getPayloadInfo(payload, title)
    const faqInfo = this._getFaqInfo(faqs)

    return this._modelDetailContentValueObjectFactory({
      title,
      ...payloadInfo,
      ...faqInfo
    })
  }
}
